import { render, staticRenderFns } from "./NotiificationList.vue.js?vue&type=template&id=66b48ebe!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotiificationList.vue?vue&type=template&id=66b48ebe"
import script from "./NotiificationList.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotiificationList.vue?vue&type=script&lang=js"
export * from "./NotiificationList.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotiificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports